import './DeleteMyAccount.scss'
import React, { useState } from 'react'
import translate from '../../../utilities/translate'
import translations from './translations'
import SecondaryButton from '../../../widgets/Button/SecondaryButton'
import PrimaryButton from '../../../widgets/Button/PrimaryButton'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  confirm,
  deleting,
  error,
  locale,
}) => {
  const [ confirmDeleteOpen, setConfirmDeleteOpen ] = useState(false)

  return (
    <div className={ `delete-my-account ${confirmDeleteOpen ? 'unfold' : ''}` }>
      {confirmDeleteOpen
        ? <div>
          <p>{trans(locale)('areYouSure')}</p>

          { null !== error
            ? <p className="error">{ error.code === 409 ? error.message : trans(locale)('error') }</p>
            : null
          }

          <div className="delete-confirmation-buttons">
            <SecondaryButton disabled={ deleting } onClick={ () => confirm() }>{ trans(locale)('yes') }</SecondaryButton>
            <PrimaryButton disabled={ deleting } onClick={ () => setConfirmDeleteOpen(false) }>{ trans(locale)('no') }</PrimaryButton>
          </div>
        </div>
        : <SecondaryButton onClick={ () => setConfirmDeleteOpen(true) }>{ trans(locale)('deleteMyAccount') }</SecondaryButton>
      }
    </div>
  )
}
